import { AxiosPromise } from 'axios';

import { browserApiRequest } from '@/utils/apiRequest/browserApiRequest';

export function postRequestAccess(
	id: string,
	firstName: string,
	lastName: string,
	email: string,
): AxiosPromise {
	return browserApiRequest({
		endpoint: 'b2b/users/subscription/request',
		method: 'POST',
		body: {
			partner_id: id,
			first_name: firstName,
			last_name: lastName,
			work_email: email,
		},
	});
}
